import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";

import { arrayGetStripedValues } from "./array";

/**
 * Return true if object is empty like {} or {name: ""}
 * @method objectIsEmpty
 * @param {object}
 * @return {boolean}
 */
export const objectIsEmpty = (object) =>
  isEmpty(object) || !Object.keys(object).find((key) => !isEmpty(object[key]));

export const objectGetAllArrayStripedValues = (object) => {
  if (objectIsEmpty(object)) {
    return object;
  }
  let newObject = {};
  Object.keys(object).forEach((value) => {
    newObject = {
      ...newObject,
      [value]: Array.isArray(object[value])
        ? arrayGetStripedValues(object[value]) || ""
        : object[value],
    };
  });
  return newObject;
};

/**
 * Returns an object with new attributes
 * @method transferAttributes
 * @param {array} Array of properties to transfer
 * @param {source} Object source
 * @param {target} Object target
 * @return {boolean} Object source
 */
export const transferAttributes = (array, source, target, useKey = true) => {
  const newTarget = cloneDeep(target);
  const newSource = cloneDeep(source);

  array.forEach((key, index) => {
    const value = newSource[useKey ? key : index];
    Object.defineProperty(newTarget, key, { value, enumerable: true });
  });

  return newTarget;
};
